export default __webpack_public_path__ + "static/cruiselines-royal-activities-5-3a886964d9ae7234cf97f4389c7ab2fc.jpg";